import AuthenticatedResource from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class MerchDetailsResource extends AuthenticatedResource {
  static urlRoot = '/merch_details'
  
  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }

}